import { render } from "./empat.vue?vue&type=template&id=5f2e44ce"
import script from "./empat.vue?vue&type=script&lang=js"
export * from "./empat.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__